export default __webpack_public_path__ + "static/media/hacktiv-bg.839370cc.png";